import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { UtilisateurDto } from '../../dto/utilisateur-dto';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmDeleteModalComponent } from '../confirm-delete-modal/confirm-delete-modal.component';
import { AddUserModalComponent } from '../add-user-modal/add-user-modal.component';
import { EditUserModalComponent } from '../edit-user-modal/edit-user-modal.component';
import { UtilisateursService } from '../../service/utilisateurs.service';

@Component({
  selector: 'app-utilisateurs',
  templateUrl: './utilisateurs.component.html',
  styleUrls: ['./utilisateurs.component.scss']
})
export class UtilisateursComponent implements OnInit {
  utilisateurs$!: Observable<UtilisateurDto[]>;
  selectedRowIndex: number | null = null;

  constructor(
    private utilisateursService: UtilisateursService,
    private modalService: NgbModal
  ) {}

  ngOnInit(): void {
    this.utilisateurs$ = this.utilisateursService.getAllUtilisateurs();
  }

  handleRowClick(index: number): void {
    this.selectedRowIndex = index;
  }

  openEditionModal(utilisateur: UtilisateurDto): void {
    const modalRef = this.modalService.open(EditUserModalComponent, { size: 'lg' });
    modalRef.componentInstance.utilisateur = utilisateur;
    modalRef.result.then(
      (result) => {
        if (result === 'edited') {
          this.refreshUsersList();
        }
      },
      (reason) => {}
    );
  }

  openDeleteModal(utilisateur: UtilisateurDto): void {
    const modalRef = this.modalService.open(ConfirmDeleteModalComponent, { size: 'lg' });
    const modalComponent = modalRef.componentInstance;
    modalComponent.utilisateur = utilisateur;
    modalRef.result.then(
      (result) => {
        if (result === 'delete') {
          this.deleteUtilisateur(utilisateur);
        }
      },
      (reason) => {}
    );
  }

  deleteUtilisateur(utilisateur: UtilisateurDto): void {
    this.utilisateursService.deleteUtilisateur(utilisateur.id).subscribe({
      next: () => {
        this.refreshUsersList();
      },
      error: (err) => {
        console.error('Erreur lors de la suppression:', err);
      }
    });
  }

  openAddModal(): void {
    const modalRef = this.modalService.open(AddUserModalComponent, { size: 'lg' });
    modalRef.result.then(
      (result) => {
        if (result === 'added') {
          this.refreshUsersList();
        }
      },
      (reason) => {}
    );
  }

  refreshUsersList(): void {
      this.utilisateurs$ = this.utilisateursService.getAllUtilisateurs();
  }
}
